import { useMemo } from "react";

export default function StarField({ count = 90, className = "" }) {
  const stars = useMemo(() => {
    const arr = [];
    for (let i = 0; i < count; i++) {
      const size = Math.random() * 2 + 0.4;
      arr.push({
        top: Math.random() * 100,
        left: Math.random() * 100,
        size,
        delay: Math.random() * 4,
        duration: 3 + Math.random() * 4,
        opacity: 0.35 + Math.random() * 0.55,
      });
    }
    return arr;
  }, [count]);

  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      data-testid="starfield"
      aria-hidden="true"
    >
      {stars.map((s, i) => (
        <span
          key={i}
          className="rts-star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            opacity: s.opacity,
            boxShadow: s.size > 1.4 ? `0 0 6px rgba(248,249,250,0.8)` : "none",
          }}
        />
      ))}
    </div>
  );
}
